import { Stack } from "expo-router";
import React from "react";
import { View } from "react-native";

export default function AccountLayout() {
  return (

    <Stack
      screenOptions={{
        headerShown: false,
      }}
    >
      <Stack.Screen name="index" />
    </Stack>

  );
}